import { Component, OnInit, Input } from '@angular/core';
import { QuickStatsComponent } from '../../../widget-library/widgets/quick-stats/quick-stats.component';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import * as _ from 'underscore';
import * as numeral from 'numeral';
import { PATHS } from '../../../analytics/constants/analytics.constants';
import * as jQuery from 'jquery';
import { AnalyticsDataChachingService } from '../../../analytics/services/analytics.datacaching.service';
@Component({
	selector: 'app-quick-stats-r10',
	templateUrl: './quick-stats-r10.component.html',
	styleUrls: ['./quick-stats-r10.component.css']
})
export class QuickStatsR10Component extends QuickStatsComponent implements OnInit {
	@Input() legend: any;
	@Input() iscustomendpoint: any;
	@Input() uniqueoverwriteid: string;
	@Input() getdatafromwidget: string;
	public showRate: boolean = false;
	public currentVersion: boolean = false;
	public isR13: boolean = false;
	public isR10: boolean = false;
	public widgetIdProcesReq: string;
	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected AnalyticsDataChachingService: AnalyticsDataChachingService
	) {
		super(analyticsService, analyticsDataModel);
	}

	ngOnInit(): void {
		this.legend = JSON.parse(decodeURI(this.legend));
		this.currentVersion = this.analyticsDataModel.config.version.toLowerCase() === 'r10' ? true : false;
		this.isR13 = this.analyticsDataModel.config.version.toLowerCase() === 'r13' ? true : false;
		this.isR10 = this.analyticsDataModel.config.version.toLowerCase() === 'r10' ? true : false;
		super.ngOnInit();
	}
	requestData() {
		this.hasData = true;
		this.showLoad = true;
		this.widgetIdProcesReq =
			!this.widgetIdProcesReq && this.getdatafromwidget && this.getdatafromwidget != 'undefined'
				? !this.AnalyticsDataChachingService.checkSelectionsChanges(this.getdatafromwidget)
					? this.AnalyticsDataChachingService.ANALYTICS_WIDGETS_CACHED_DATA.data[this.getdatafromwidget]?.['response']
						? this.getdatafromwidget
						: this.uniqueoverwriteid
					: this.uniqueoverwriteid
				: this.uniqueoverwriteid;
		if (this.iscustomendpoint == 'true') {
			this.widgetDataSubscription = this.analyticsService
				.processCustomServiceRequest(this.key, null, null, null, null, this.widgetIdProcesReq)
				.subscribe((res: any) => {
					this.showLoad = false;
					let res_data = res.success ? res.data[0] : [];
					this.hasData = res.success;
					this.processResponseData(res_data);
				});
		} else {
			this.widgetDataSubscription = this.analyticsService
				.processWidgetRequest(this.key, null, null, this.widgetIdProcesReq)
				.subscribe((res: any) => {
					this.showLoad = false;
					let res_data = res.success ? res.data[0] : [];
					this.hasData = res.success;
					this.processResponseData(res_data);
				});
		}
	}
	processResponseData(response) {
		const responseKeys = Object.keys(response);
		//filtering legend by permission
		this.legend = _.filter(this.legend, (item) => {
			return this.analyticsDataModel.checkComponentForPermission(item);
		});

		this.quickStatsData = _.map(this.legend, (legend, index) => {
			let isClickrate = false;
			let withClickrate = false;
			if (response[legend['value']]) {
				let hasPercent =
					responseKeys.includes(`${legend['value']}_rate`) || responseKeys.includes(`${legend['value']}_percent`);
				let percent_value = hasPercent
					? numeral(response[`${legend['value']}_rate`] || response[`${legend['value']}_percent`]).format('0,0.00') +
					  '%'
					: '';
				// for CTV as view_throughs is household site visits and for household site visits we dont show percent value.
				// the below code will disable percent value to it.
				const currentProduct = this.analyticsDataModel.getCurrentPath();
				if (currentProduct === PATHS.CTV) {
					if (legend['displayName'] == 'household site visits') {
						hasPercent = false;
					}
				}
				if (currentProduct === PATHS.GAM && this.isR13) {
					withClickrate = true;
					if (legend['displayName'] == 'click rate') {
						hasPercent = true;
						isClickrate = true;
						percent_value = hasPercent ? numeral(response[`${legend['value']}`]).format('0,0.00') + '%' : '';
					}
				}
				if (response[legend['value']] == '0') {
					return {
						name: legend['displayName'],
						value: '0',
						hasPercent: hasPercent,
						percent_value: percent_value,
						title: legend['title'],
						secondaryTitle: legend['secondaryTitle'],
						tertiaryTitle: legend['tertiaryTitle'],
						isClickrate: isClickrate,
						withClickrate: withClickrate
					};
				}
				return {
					name: legend['displayName'],
					value: Number(response[legend['value']].split(',').join('')) || response[legend['value']],
					hasPercent: hasPercent,
					percent_value: percent_value,
					title: legend['title'],
					secondaryTitle: legend['secondaryTitle'],
					tertiaryTitle: legend['tertiaryTitle'],
					isClickrate: isClickrate,
					withClickrate: withClickrate
				};
			} else {
				return {
					name: legend['displayName'],
					value: '',
					title: legend['title'],
					secondaryTitle: legend['secondaryTitle'],
					tertiaryTitle: legend['tertiaryTitle'],
					isClickrate: isClickrate,
					withClickrate: withClickrate
				};
			}
		});
	}
	// hiding the code , need to refactor : issue with smooth transition of tooltip follow through style
	cursorPositon(e) {
		// 	let x = e.offsetX;
		// 	let y = e.offsetY;
		// 	if (x >= 0 && y >= 0) {
		// 		jQuery(
		// 			'.widget-grid .tab-content .stats-container .stats .stat-div.stat-div-r10:not(.stat-div-last) .tooltip-container:hover .tooltip'
		// 		).css({ top: y, left: x + 2 });
		// 		jQuery(
		// 			'.widget-grid .tab-content .stats-container .stats:last-child  .stat-div.stat-div-r10.stat-div-last .tooltip-container:hover .tooltip'
		// 		).css({ top: y, right: e.currentTarget.clientWidth - x + 2 });
		// 	}
	}
}
